import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "py-16 md:py-24" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-6 lg:px-10 xl:px-14" }
const _hoisted_3 = { class: "mx-auto w-full max-w-3xl space-y-8" }
const _hoisted_4 = { class: "rounded-2xl bg-white/80 supports-[backdrop-filter]:backdrop-blur-md shadow-xl ring-1 ring-black/5 p-6 md:p-8" }
const _hoisted_5 = { class: "mt-2 flex items-center rounded-xl border bg-white/95 border-slate-200 focus-within:ring-2 focus-within:ring-emerald-500/25 focus-within:border-emerald-400 transition" }
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "inline-flex items-center gap-2"
}

import { ref } from 'vue'
import TopBanner from '@/components/TopBanner.vue'
import Auth from '@/composables/Auth'
import { handleApiError } from '@/utils/common'
import { NotificationType } from '@/types'
import Notification from '@/widgets/Notification.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgetPassword',
  setup(__props) {

const email = ref<string>('')
const isLoading = ref<boolean>(false)
const { forgetPassword } = Auth()
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})

const handleResetPassword = async () => {
  if (email.value !== '' && !isLoading.value) {
    isLoading.value = true
    const response = await forgetPassword(email.value)
    isLoading.value = false

    if (response.status === 200) {
      notif.value = {
        show: true,
        type: 'success',
        message: 'Email Sent',
        messageDetails: 'An email has been sent at your provided address'
      }
      resetForm()
    } else {
      const error = handleApiError(response)
      notif.value = { show: true, type: 'error', message: error, messageDetails: '' }
      setTimeout(() => { notifClosed() }, 4000)
    }
  }
}

const resetForm = (): void => {
  email.value = ''
}

const notifClosed = () => {
  notif.value.show = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopBanner, {
      layout: "full-width",
      currentPage: "Forget Password",
      heading: "Forget Password",
      bannerClass: "banner-auth"
    }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "flex items-start gap-4 rounded-2xl bg-amber-50/80 supports-[backdrop-filter]:backdrop-blur-md ring-1 ring-amber-200/70 p-5 md:p-6",
            role: "status",
            "aria-live": "polite"
          }, [
            _createElementVNode("div", { class: "relative shrink-0" }, [
              _createElementVNode("div", { class: "h-11 w-11 rounded-full bg-white shadow ring-1 ring-black/5 grid place-items-center" }, [
                _createElementVNode("span", {
                  class: "font-icon theme-icon info-icon text-theme-active text-[28px]",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _createElementVNode("div", { class: "text-amber-900" }, [
              _createElementVNode("h4", { class: "font-semibold text-[16px] md:text-[17px]" }, "Information"),
              _createElementVNode("p", { class: "mt-1 text-[14px] md:text-[15px] text-amber-800/90" }, " Lost your password? Please enter your username or email address. You will receive a link to create a new password via email. ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleResetPassword, ["prevent"]),
              class: "space-y-6"
            }, [
              _createElementVNode("div", null, [
                _cache[1] || (_cache[1] = _createElementVNode("label", {
                  for: "login-username",
                  class: "block uppercase text-[11px] tracking-widest text-slate-500"
                }, " Username or email address * ", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    type: "text",
                    id: "login-username",
                    autocomplete: "username email",
                    class: "w-full h-[46px] md:h-[52px] bg-transparent outline-none text-slate-800 placeholder-slate-400 px-3 text-[15px] font-medium",
                    placeholder: "you@example.com",
                    "aria-required": "true"
                  }, null, 512), [
                    [_vModelText, email.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: !email.value || isLoading.value,
                  class: "inline-flex items-center justify-center rounded-full px-6 md:px-8 py-3 border-2 border-emerald-600 bg-emerald-600 text-white uppercase tracking-wide text-xs md:text-[12px] font-semibold shadow hover:bg-white hover:text-emerald-700 transition disabled:opacity-40 disabled:cursor-not-allowed"
                }, [
                  (!isLoading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Reset password"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[2] || (_cache[2] = [
                        _createElementVNode("svg", {
                          class: "animate-spin",
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          "aria-hidden": "true"
                        }, [
                          _createElementVNode("path", {
                            d: "M12 2a10 10 0 100 20",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round"
                          })
                        ], -1),
                        _createTextVNode(" Processing… ")
                      ])))
                ], 8, _hoisted_7),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-slate-500 text-sm" }, " We’ll send a reset link if the email/username exists. ", -1))
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"])
  ], 64))
}
}

})